import * as Sentry from "@sentry/nextjs";
import settings from "./src/settings";

if (settings.SENTRY_DSN) {
  Sentry.init({
    dsn: settings.SENTRY_DSN,
    environment: settings.APP_ENV,
  });
}
